import React, { FC, useRef } from 'react'
import { Field } from 'react-final-form'
import { Hidden } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { BUILD_CONSTANTS as BC, FORM_ID, TRANSLATIONS as T } from '../../../constants'
import { PartnerName, ProductName } from '../../../types/interface/quote.interface'
import useLogic from './useLogic'
import {
  AvtalegiroForm,
  ExternalSubmitBtn,
  LDCardTwoColV2FSM,
  LMBasicV3FSM,
  ProductWrapper,
  RFFCustomCheckbox,
  withHidden,
} from '@dg-shared'
import { useTranslate } from '../../../hooks/shared'
import FormBuilder from '@dg-shared/forms/FormBuilder'
import Loading from '../Loading/Page'
import VerifyCard from './Card'
import OfferDetails from './Details'
import { CommonPageProps } from '../../../types/interface/fsm.interface'

const MobileScreen = withHidden(LMBasicV3FSM, true)
const DesktopScreen = withHidden(LDCardTwoColV2FSM, false)

const useStyles = makeStyles(() =>
  createStyles({
    checkbox: {
      '& .MuiButtonBase-root': {
        padding: '9px 9px 9px 9px',
      },
    },
  })
)

const VerifyPage: FC<CommonPageProps> = ({ service }) => {
  const { t } = useTranslate(T.OFFER_VERIFY)
  const paymentRef = useRef<HTMLFormElement | null>(null)
  const { btnDisabled, loading, formData, KID } = useLogic(service.send)
  const quoteData = !!formData && formData.quote

  const styles = useStyles()

  const formPayment = quoteData && (
    <AvtalegiroForm
      actionUrl={`${BC.AVTALEGIRO_URL}/ecsa/start`}
      componentRef={paymentRef}
      companyName={BC.PARTNER_NAME_AVTALEGIRO}
      companyAccountNumber={BC.ACCOUNT_NUMBER}
      data={quoteData}
      kid={KID as string}
      returnUrl={`${BC.REST_URL}/payment`}
      notificationDisabled='false'
    />
  )

  //TODO: Work on this structure later.
  const offerForm = !!formData && (
    <>
      <FormBuilder
        id={FORM_ID.VERIFY}
        filledFieldsData={formData.formValue}
        handleBtnDisabled={formData.handleBtnDisabled}
        initialValues={{ policyDate: formData.date.selected }}
        setFormState={formData.changeHandler}
        validationArgs={{ ...formData.date }}
        submitHandler={(values) => formData.handleSubmit(paymentRef, values)}
        externalDependency={{ insuranceCompany: formData.quote.displayPrevCompanyField }}
        isFormControllable
        customSubmit
      >
        <Hidden mdUp>
          <VerifyCard offer={formData.quote} />
        </Hidden>

        <OfferDetails />
        <Field
          name='agreementConfirm'
          type='agreementConfirm'
          fieldLabel={t(`form.agreementConfirm.label`)}
        >
          {(props) => <RFFCustomCheckbox {...props} className={styles.checkbox} />}
        </Field>
        <ProductWrapper products={[ProductName.VEHICLE]} partners={[PartnerName.circlek]}>
          <Field
            name='consentSharing'
            type='consentSharing'
            fieldLabel={t(`form.consentSharing.label`)}
          >
            {(props) => <RFFCustomCheckbox {...props} className={styles.checkbox} />}
          </Field>
        </ProductWrapper>
      </FormBuilder>
      {formPayment}
    </>
  )

  const externalSubmitBtn = (
    <ExternalSubmitBtn text={t('submit')} targetId={FORM_ID.VERIFY} disabled={btnDisabled} />
  )

  const cardOffer = !!quoteData && <VerifyCard offer={quoteData} />

  if (loading) {
    return (
      <>
        {formPayment}
        <Loading />
      </>
    )
  }

  return (
    <>
      <MobileScreen
        send={service.send}
        breadcrumbs
        breadcrumbsBtnText={t(`back`)}
        titleHeader={t('title')}
        breadcrumbsStepPercentage={80}
      >
        {offerForm}
        {externalSubmitBtn}
      </MobileScreen>

      <DesktopScreen
        send={service.send}
        colLeft={offerForm}
        colRight={cardOffer}
        title={t('title')}
        breadcrumbsStepPercentage={80}
        nextBtn={externalSubmitBtn}
        breadcrumbsBtnText={t(`back`)}
        breadcrumbs
      />
    </>
  )
}

export default VerifyPage
